// Native American Warriors Data - Group Five (Final Mixed Nations)

// Pushmataha's workout programs
const pushmatahaPrograms = [
    {
        id: 'choctaw-diplomat-training',
        name: 'Choctaw Diplomat Training',
        description: 'Balanced conditioning combining southeastern warrior tradition with diplomatic wisdom',
        pattern: 'ya@wd',
        reps: 15,
        sets: 4,
        focus: 'Diplomatic Warrior'
    },
    {
        id: 'mississippi-valley-conditioning',
        name: 'Mississippi Valley Conditioning',
        description: 'River valley strength training in the rich Mississippi Delta territories',
        pattern: '@wyad',
        reps: 17,
        sets: 3,
        focus: 'Delta Power'
    },
    {
        id: 'war-of-1812-workout',
        name: 'War of 1812 Workout',
        description: 'Allied warrior conditioning for fighting alongside American forces',
        pattern: 'wa@yd',
        reps: 19,
        sets: 3,
        focus: 'Allied Warfare'
    },
    {
        id: 'three-medals-protocol',
        name: 'Three Medals Protocol',
        description: 'Triple honor conditioning representing medals from three different governments',
        pattern: 'y@wad',
        reps: 13,
        sets: 5,
        focus: 'Triple Honor'
    },
    {
        id: 'southeastern-elder-training',
        name: 'Southeastern Elder Training',
        description: 'Wisdom-based conditioning from the distinguished elders of the Southeast',
        pattern: 'ady@w',
        reps: 11,
        sets: 6,
        focus: 'Elder Wisdom'
    },
    {
        id: 'distinguished-chief-mastery',
        name: 'Distinguished Chief Mastery',
        description: 'Ultimate training for one of the most respected Choctaw leaders in history',
        pattern: 'ya@wd!',
        reps: 21,
        sets: 3,
        focus: 'Distinguished Leadership'
    }
];

// Sequoyah's workout programs
const sequoyahPrograms = [
    {
        id: 'cherokee-scholar-training',
        name: 'Cherokee Scholar Training',
        description: 'Intellectual warrior conditioning combining physical strength with mental brilliance',
        pattern: 'za@wd',
        reps: 14,
        sets: 4,
        focus: 'Scholar Warrior'
    },
    {
        id: 'syllabary-creator-conditioning',
        name: 'Syllabary Creator Conditioning',
        description: 'Innovation strength training for those who create lasting intellectual achievements',
        pattern: '@wzad',
        reps: 16,
        sets: 4,
        focus: 'Creative Innovation'
    },
    {
        id: 'blue-ridge-workout',
        name: 'Blue Ridge Workout',
        description: 'Mountain conditioning in the beautiful Blue Ridge territories of Cherokee land',
        pattern: 'wa@zd',
        reps: 18,
        sets: 3,
        focus: 'Mountain Scholar'
    },
    {
        id: 'literacy-warrior-protocol',
        name: 'Literacy Warrior Protocol',
        description: 'Educational conditioning for warriors who fight ignorance with knowledge',
        pattern: 'z@wad',
        reps: 20,
        sets: 3,
        focus: 'Educational Warfare'
    },
    {
        id: 'cultural-preservation-training',
        name: 'Cultural Preservation Training',
        description: 'Heritage conditioning for preserving Cherokee culture through written language',
        pattern: 'adz@w',
        reps: 12,
        sets: 5,
        focus: 'Cultural Legacy'
    },
    {
        id: 'intellectual-legend-mastery',
        name: 'Intellectual Legend Mastery',
        description: 'Complete mastery for the Cherokee genius who gave his people written language',
        pattern: 'za@wd!',
        reps: 22,
        sets: 3,
        focus: 'Intellectual Legacy'
    }
];

// Gall's workout programs
const gallPrograms = [
    {
        id: 'fierce-warrior-training',
        name: 'Fierce Warrior Training',
        description: 'Intense battle conditioning for warriors known for their fearless aggression',
        pattern: 'ua@wd',
        reps: 20,
        sets: 3,
        focus: 'Fierce Aggression'
    },
    {
        id: 'lakota-battle-fury-conditioning',
        name: 'Lakota Battle Fury Conditioning',
        description: 'Explosive combat training channeling the legendary Lakota warrior spirit',
        pattern: '@wuad',
        reps: 18,
        sets: 3,
        focus: 'Battle Fury'
    },
    {
        id: 'little-bighorn-workout',
        name: 'Little Bighorn Workout',
        description: 'Victory conditioning commemorating the greatest Native American military triumph',
        pattern: 'wa@ud',
        reps: 22,
        sets: 3,
        focus: 'Victory Celebration'
    },
    {
        id: 'charging-bear-protocol',
        name: 'Charging Bear Protocol',
        description: 'Unstoppable assault conditioning like a charging bear in battle',
        pattern: 'u@wad',
        reps: 24,
        sets: 3,
        focus: 'Unstoppable Charge'
    },
    {
        id: 'warrior-rage-training',
        name: 'Warrior Rage Training',
        description: 'Controlled fury conditioning for channeling rage into devastating effectiveness',
        pattern: 'adu@w',
        reps: 16,
        sets: 4,
        focus: 'Controlled Fury'
    },
    {
        id: 'legendary-fighter-mastery',
        name: 'Legendary Fighter Mastery',
        description: 'Ultimate training for one of the most feared Lakota warriors in battle',
        pattern: 'ua@wd!',
        reps: 26,
        sets: 3,
        focus: 'Legendary Ferocity'
    }
];

// American Horse's workout programs
const americanHorsePrograms = [
    {
        id: 'peace-transition-training',
        name: 'Peace Transition Training',
        description: 'Adaptive conditioning for warriors transitioning from war to peace leadership',
        pattern: 'ja@wd',
        reps: 13,
        sets: 4,
        focus: 'Peace Transition'
    },
    {
        id: 'lakota-elder-conditioning',
        name: 'Lakota Elder Conditioning',
        description: 'Wisdom-based strength training for guiding people through changing times',
        pattern: '@wjad',
        reps: 15,
        sets: 4,
        focus: 'Elder Guidance'
    },
    {
        id: 'great-plains-sunset-workout',
        name: 'Great Plains Sunset Workout',
        description: 'Reflective conditioning as the sun sets on the traditional warrior way of life',
        pattern: 'wa@jd',
        reps: 17,
        sets: 3,
        focus: 'Sunset Reflection'
    },
    {
        id: 'dignified-surrender-protocol',
        name: 'Dignified Surrender Protocol',
        description: 'Noble conditioning for those who choose survival and dignity over futile resistance',
        pattern: 'j@wad',
        reps: 11,
        sets: 5,
        focus: 'Dignified Choice'
    },
    {
        id: 'legacy-preservation-training',
        name: 'Legacy Preservation Training',
        description: 'Future-focused conditioning for preserving culture and people for generations to come',
        pattern: 'adj@w',
        reps: 19,
        sets: 3,
        focus: 'Future Legacy'
    },
    {
        id: 'wise-leader-mastery',
        name: 'Wise Leader Mastery',
        description: 'Complete mastery for leaders who choose the hardest path - survival through adaptation',
        pattern: 'ja@wd!',
        reps: 18,
        sets: 3,
        focus: 'Adaptive Wisdom'
    }
];

// Lozen's workout programs
const lozenPrograms = [
    {
        id: 'apache-woman-warrior-training',
        name: 'Apache Woman Warrior Training',
        description: 'Female warrior conditioning breaking all traditional gender barriers in combat',
        pattern: 'va@wd',
        reps: 18,
        sets: 3,
        focus: 'Female Warrior'
    },
    {
        id: 'spiritual-scout-conditioning',
        name: 'Spiritual Scout Conditioning',
        description: 'Sacred power training for locating enemies through spiritual connection',
        pattern: '@wvad',
        reps: 16,
        sets: 4,
        focus: 'Spiritual Scouting'
    },
    {
        id: 'desert-sister-workout',
        name: 'Desert Sister Workout',
        description: 'Sisterly bond conditioning fighting alongside her brother Victorio',
        pattern: 'wa@vd',
        reps: 20,
        sets: 3,
        focus: 'Sisterly Bond'
    },
    {
        id: 'medicine-woman-protocol',
        name: 'Medicine Woman Protocol',
        description: 'Healing warrior conditioning combining combat skills with sacred medicine knowledge',
        pattern: 'v@wad',
        reps: 14,
        sets: 4,
        focus: 'Healing Warrior'
    },
    {
        id: 'apache-freedom-training',
        name: 'Apache Freedom Training',
        description: 'Liberation conditioning for those who choose death before captivity',
        pattern: 'adv@w',
        reps: 22,
        sets: 3,
        focus: 'Freedom Choice'
    },
    {
        id: 'legendary-woman-mastery',
        name: 'Legendary Woman Mastery',
        description: 'Ultimate training for the most famous female Native American warrior',
        pattern: 'va@wd!',
        reps: 24,
        sets: 3,
        focus: 'Legendary Femininity'
    }
];

// Nana's workout programs
const nanaPrograms = [
    {
        id: 'apache-survivor-training',
        name: 'Apache Survivor Training',
        description: 'Elder endurance conditioning for those who outlast all enemies through sheer determination',
        pattern: 'pa@wd',
        reps: 12,
        sets: 5,
        focus: 'Survivor Endurance'
    },
    {
        id: 'ancient-warrior-conditioning',
        name: 'Ancient Warrior Conditioning',
        description: 'Old age strength training proving that experience trumps youth in warfare',
        pattern: '@wpad',
        reps: 10,
        sets: 6,
        focus: 'Ancient Strength'
    },
    {
        id: 'desert-grandfather-workout',
        name: 'Desert Grandfather Workout',
        description: 'Grandfatherly conditioning leading young warriors through desert campaigns',
        pattern: 'wa@pd',
        reps: 14,
        sets: 4,
        focus: 'Grandfatherly Leadership'
    },
    {
        id: 'unstoppable-elder-protocol',
        name: 'Unstoppable Elder Protocol',
        description: 'Relentless conditioning for elders who refuse to give up despite overwhelming odds',
        pattern: 'p@wad',
        reps: 16,
        sets: 4,
        focus: 'Relentless Elder'
    },
    {
        id: 'final-campaign-training',
        name: 'Final Campaign Training',
        description: 'Last stand conditioning for the final Apache resistance campaigns',
        pattern: 'adp@w',
        reps: 18,
        sets: 3,
        focus: 'Final Resistance'
    },
    {
        id: 'indomitable-spirit-mastery',
        name: 'Indomitable Spirit Mastery',
        description: 'Ultimate training for the Apache elder who never stopped fighting',
        pattern: 'pa@wd!',
        reps: 20,
        sets: 3,
        focus: 'Indomitable Will'
    }
];

// Main Native American warriors data object - Group Five
const nativeAmericanFiveTrainersData = {
    'pushmataha': {
        id: 'pushmataha',
        name: 'Pushmataha',
        specialization: 'Diplomatic Warfare & Southeastern Wisdom',
        image: '/assets/images/Pushmataha.jpg',
        experience: '75+ years',
        category: 'native-american',
        color: '#8B4513',
        secondaryColor: '#C0C0C0',
        intro: `The distinguished Choctaw chief who served three nations and earned medals from each, Pushmataha mastered the delicate balance between warfare and diplomacy. His training develops the sophisticated strength needed for complex political situations while maintaining warrior readiness. Students learn that true leadership sometimes means fighting alongside former enemies for the greater good.`,
        programs: pushmatahaPrograms
    },
    'sequoyah': {
        id: 'sequoyah',
        name: 'Sequoyah',
        specialization: 'Intellectual Warfare & Cultural Innovation',
        image: '/assets/images/Sequoyah.jpg',
        experience: '82+ years',
        category: 'native-american',
        color: '#4B0082',
        secondaryColor: '#C0C0C0',
        intro: `The Cherokee genius who created the first Native American written language, Sequoyah proved that the pen could be as mighty as the sword. His training develops the intellectual strength and creative innovation needed to preserve culture through knowledge. Students learn that some victories are won not on battlefields, but in the realm of ideas and education.`,
        programs: sequoyahPrograms
    },
    'gall': {
        id: 'gall',
        name: 'Gall',
        specialization: 'Battle Fury & Unstoppable Aggression',
        image: '/assets/images/Gall.jpg',
        experience: '68+ years',
        category: 'native-american',
        color: '#8B0000',
        secondaryColor: '#C0C0C0',
        intro: `The fierce Lakota warrior whose rage in battle was legendary, Gall embodied the unstoppable fury of the plains warrior. His training develops the explosive aggression and fearless assault capabilities needed for direct confrontation. Students learn how to channel fury into devastating effectiveness while maintaining tactical awareness.`,
        programs: gallPrograms
    },
    'american-horse': {
        id: 'american-horse',
        name: 'American Horse',
        specialization: 'Peace Transition & Adaptive Leadership',
        image: '/assets/images/American-Horse.jpg',
        experience: '71+ years',
        category: 'native-american',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The Lakota leader who guided his people through the difficult transition from war to peace, American Horse understood that adaptation meant survival. His training develops the wisdom needed to choose the hardest path - preserving culture and people through compromise rather than glorious defeat. Students learn that sometimes the greatest courage is choosing life over honor.`,
        programs: americanHorsePrograms
    },
    'lozen': {
        id: 'lozen',
        name: 'Lozen',
        specialization: 'Female Warrior Power & Spiritual Combat',
        image: '/assets/images/Lozen.jpg',
        experience: '50+ years',
        category: 'native-american',
        color: '#8A2BE2',
        secondaryColor: '#C0C0C0',
        intro: `The Apache warrior woman who broke all gender barriers and fought as fiercely as any male warrior, Lozen combined spiritual power with deadly combat skills. Her training develops the unique strength that comes from proving oneself against overwhelming prejudice while maintaining sacred connection to Apache traditions and spiritual powers.`,
        programs: lozenPrograms
    },
    'nana': {
        id: 'nana',
        name: 'Nana',
        specialization: 'Elder Endurance & Indomitable Spirit',
        image: '/assets/images/Nana.jpg',
        experience: '90+ years',
        category: 'native-american',
        color: '#696969',
        secondaryColor: '#C0C0C0',
        intro: `The ancient Apache warrior who continued fighting into his eighties, Nana proved that age and experience could triumph over youth and vigor. His training develops the relentless endurance and indomitable spirit needed to outlast all enemies. Students learn that true strength comes not from physical power alone, but from an unbreakable will that refuses to surrender.`,
        programs: nanaPrograms
    }
};

// Export the data
export default nativeAmericanFiveTrainersData;